import Handlebars from 'handlebars';

import MarkdownComponent from 'dashboard/components/Markdown';
import { ModuleMarkdown } from 'dashboard/modules/Markdown/model';
import Card from 'design-system/components/Card';

export interface MarkdownProps {
  module: ModuleMarkdown;
  templateData?: Record<string, unknown>;
  isPreview?: boolean;
}

const Markdown = ({ module, templateData = {}, isPreview = false }: MarkdownProps) => {
  /* Helper to take a json object and render it in nested form
   *
   * To make sure you get the right markdown for nesting, use ```
   *
   * ex: markdown: "```{{jsonStringify data}}```"
   **/
  Handlebars.registerHelper('jsonStringify', (context: any) => {
    // NOTE: Handlebars doesn't escape the quotes so they show up as &quot so we replace before we render
    //       BETTER IDEA would be appreciated
    return `${JSON.stringify(context, null, 2)?.replace(/"/g, '') ?? ''}`;
  });

  Handlebars.registerHelper('encodeURIComponent', (context: any) => {
    return encodeURIComponent(context);
  });

  const template = Handlebars.compile(module.markdown, { noEscape: true });

  return (
    <Card data-test={`module__markdown--${module.token}`}>
      <Card.Body>
        <MarkdownComponent>
          {isPreview ? module.markdown : template(templateData)}
        </MarkdownComponent>
      </Card.Body>
    </Card>
  );
};

export default Markdown;
